var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoFound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 114,
    viewBox: "0 0 120 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0314 50.4422C33.2085 50.9272 33.7823 52.3067 33.3131 53.5234L26.0759 72.2904H39.3379C40.605 72.2904 41.6322 73.3522 41.6322 74.662C41.6322 75.9719 40.605 77.0337 39.3379 77.0337H19.3069L29.0506 51.767C29.5198 50.5503 30.8544 49.9572 32.0314 50.4422Z",
    fill: "url(#paint0_linear_2577_2660)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.1131 62.6788C39.3016 63.9741 38.4386 65.182 37.1856 65.3768L18.1242 68.3407C16.8712 68.5356 15.7026 67.6435 15.5141 66.3483C15.3256 65.0531 16.1886 63.8451 17.4416 63.6503L36.503 60.6864C37.7561 60.4915 38.9246 61.3836 39.1131 62.6788Z",
    fill: "url(#paint1_linear_2577_2660)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6881 14.1648L22.1176 27.2196L31.6895 40.2791L41.2602 27.2219L31.6881 14.1648ZM28.4838 10.6823C29.2176 9.67679 30.3856 9.03564 31.6889 9.03564C32.9984 9.03564 34.1639 9.68421 34.8939 10.6843C34.8948 10.6856 34.8957 10.6869 34.8967 10.6882L45.1991 24.7414L45.2017 24.7449C45.696 25.4245 46.0032 26.2834 46.0032 27.2207C46.0032 28.1594 45.6952 29.015 45.2068 29.6917L45.2017 29.6987L34.8923 43.7639L34.8885 43.7689C34.1575 44.7607 32.9974 45.4058 31.6889 45.4058C30.3764 45.4058 29.2132 44.7548 28.4836 43.7596L18.1787 29.6999L18.1762 29.6965C17.6818 29.017 17.3747 28.1581 17.3747 27.2207C17.3747 26.282 17.6826 25.4264 18.1711 24.7497L18.1762 24.7426L28.4811 10.6859C28.482 10.6847 28.4829 10.6835 28.4838 10.6823Z",
    fill: "url(#paint2_linear_2577_2660)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.53 26.3635C17.9883 25.1424 19.3175 24.5366 20.4988 25.0103L31.0839 29.2555C31.4608 29.4069 31.917 29.4069 32.2939 29.2555L42.8789 25.0103C44.0602 24.5366 45.3895 25.1424 45.8478 26.3635C46.3061 27.5847 45.72 28.9586 44.5387 29.4324L33.9555 33.6768C33.9552 33.6769 33.9549 33.6771 33.9546 33.6772C32.5094 34.2573 30.8684 34.2573 29.4232 33.6772C29.4229 33.6771 29.4225 33.6769 29.4222 33.6768L18.8391 29.4324C17.6578 28.9586 17.0717 27.5847 17.53 26.3635Z",
    fill: "url(#paint3_linear_2577_2660)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.63287 0H94.0828V56.5892C94.0828 57.899 93.0556 58.9608 91.7885 58.9608C90.5214 58.9608 89.4942 57.899 89.4942 56.5892V4.74323H13.2215V92.6217H67.7487C69.0158 92.6217 70.043 93.6835 70.043 94.9933C70.043 96.3031 69.0158 97.3649 67.7487 97.3649H8.63287V0Z",
    fill: "url(#paint4_linear_2577_2660)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.9708 27.221C47.9708 25.9112 48.998 24.8494 50.2651 24.8494H78.6759C79.943 24.8494 80.9702 25.9112 80.9702 27.221C80.9702 28.5308 79.943 29.5926 78.6759 29.5926H50.2651C48.998 29.5926 47.9708 28.5308 47.9708 27.221Z",
    fill: "url(#paint5_linear_2577_2660)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.9708 36.2571C47.9708 34.9473 48.998 33.8855 50.2651 33.8855H76.4904C77.7576 33.8855 78.7848 34.9473 78.7848 36.2571C78.7848 37.5669 77.7576 38.6287 76.4904 38.6287H50.2651C48.998 38.6287 47.9708 37.5669 47.9708 36.2571Z",
    fill: "url(#paint6_linear_2577_2660)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.9708 18.1851C47.9708 16.8753 48.998 15.8135 50.2651 15.8135H72.1196C73.3867 15.8135 74.4139 16.8753 74.4139 18.1851C74.4139 19.4949 73.3867 20.5567 72.1196 20.5567H50.2651C48.998 20.5567 47.9708 19.4949 47.9708 18.1851Z",
    fill: "url(#paint7_linear_2577_2660)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.1808 65.6626C48.1808 64.3528 49.208 63.291 50.4751 63.291H67.4531C68.7203 63.291 69.7475 64.3528 69.7475 65.6626C69.7475 66.9724 68.7203 68.0342 67.4531 68.0342H50.4751C49.208 68.0342 48.1808 66.9724 48.1808 65.6626Z",
    fill: "url(#paint8_linear_2577_2660)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.1808 74.6744C48.1808 73.3645 49.208 72.3027 50.4751 72.3027H65.6177C66.8848 72.3027 67.912 73.3645 67.912 74.6744C67.912 75.9842 66.8848 77.046 65.6177 77.046H50.4751C49.208 77.046 48.1808 75.9842 48.1808 74.6744Z",
    fill: "url(#paint9_linear_2577_2660)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.9708 56.5894C47.9708 55.2796 48.998 54.2178 50.2651 54.2178H72.1196C73.3867 54.2178 74.4139 55.2796 74.4139 56.5894C74.4139 57.8992 73.3867 58.961 72.1196 58.961H50.2651C48.998 58.961 47.9708 57.8992 47.9708 56.5894Z",
    fill: "url(#paint10_linear_2577_2660)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M4.58865 95.0701C4.58865 93.7603 3.56144 92.6985 2.29432 92.6985C1.0272 92.6985 0 93.7603 0 95.0701C0 96.3799 1.0272 97.4417 2.29432 97.4417C3.56144 97.4417 4.58865 96.3799 4.58865 95.0701Z",
    fill: "url(#paint11_linear_2577_2660)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M4.58865 104.083C4.58865 102.773 3.56144 101.711 2.29432 101.711C1.0272 101.711 0 102.773 0 104.083C0 105.393 1.0272 106.455 2.29432 106.455C3.56144 106.455 4.58865 105.393 4.58865 104.083Z",
    fill: "url(#paint12_linear_2577_2660)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M4.58865 76.8093C4.58865 75.6304 3.66416 74.6748 2.52376 74.6748H2.06489C0.924483 74.6748 0 75.6304 0 76.8093C0 77.9881 0.924483 78.9437 2.06489 78.9437H2.52376C3.66416 78.9437 4.58865 77.9881 4.58865 76.8093Z",
    fill: "url(#paint13_linear_2577_2660)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M4.58865 86.0581C4.58865 84.7483 3.56144 83.6865 2.29432 83.6865C1.0272 83.6865 0 84.7483 0 86.0581C0 87.3679 1.0272 88.4298 2.29432 88.4298C3.56144 88.4298 4.58865 87.3679 4.58865 86.0581Z",
    fill: "url(#paint14_linear_2577_2660)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M4.58865 58.7853C4.58865 57.6065 3.66416 56.6509 2.52376 56.6509H2.06489C0.924483 56.6509 0 57.6065 0 58.7853C0 59.9642 0.924483 60.9198 2.06489 60.9198H2.52376C3.66416 60.9198 4.58865 59.9642 4.58865 58.7853Z",
    fill: "url(#paint15_linear_2577_2660)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M4.58865 67.7973C4.58865 66.6185 3.66416 65.6628 2.52376 65.6628H2.06489C0.924483 65.6628 0 66.6185 0 67.7973C0 68.9761 0.924483 69.9318 2.06489 69.9318H2.52376C3.66416 69.9318 4.58865 68.9761 4.58865 67.7973Z",
    fill: "url(#paint16_linear_2577_2660)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M4.58865 40.7602C4.58865 39.5814 3.66416 38.6257 2.52376 38.6257H2.06489C0.924483 38.6257 0 39.5814 0 40.7602C0 41.939 0.924483 42.8946 2.06489 42.8946H2.52376C3.66416 42.8946 4.58865 41.939 4.58865 40.7602Z",
    fill: "url(#paint17_linear_2577_2660)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M4.58865 31.7485C4.58865 30.5696 3.66416 29.614 2.52376 29.614H2.06489C0.924483 29.614 0 30.5696 0 31.7485C0 32.9273 0.924483 33.8829 2.06489 33.8829H2.52376C3.66416 33.8829 4.58865 32.9273 4.58865 31.7485Z",
    fill: "url(#paint18_linear_2577_2660)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M4.58865 22.7365C4.58865 21.5577 3.66416 20.6021 2.52376 20.6021H2.06489C0.924483 20.6021 0 21.5577 0 22.7365C0 23.9153 0.924483 24.871 2.06489 24.871H2.52376C3.66416 24.871 4.58865 23.9153 4.58865 22.7365Z",
    fill: "url(#paint19_linear_2577_2660)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M4.58865 49.7722C4.58865 48.5933 3.66416 47.6377 2.52376 47.6377H2.06489C0.924483 47.6377 0 48.5933 0 49.7722C0 50.951 0.924483 51.9066 2.06489 51.9066H2.52376C3.66416 51.9066 4.58865 50.951 4.58865 49.7722Z",
    fill: "url(#paint20_linear_2577_2660)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3071 104.083C13.3071 102.773 12.2799 101.711 11.0128 101.711C9.74565 101.711 8.71844 102.773 8.71844 104.083C8.71844 105.393 9.74565 106.455 11.0128 106.455C12.2799 106.455 13.3071 105.393 13.3071 104.083Z",
    fill: "url(#paint21_linear_2577_2660)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M30.744 104.083C30.744 102.773 29.7167 101.711 28.4496 101.711C27.1825 101.711 26.1553 102.773 26.1553 104.083C26.1553 105.393 27.1825 106.455 28.4496 106.455C29.7167 106.455 30.744 105.393 30.744 104.083Z",
    fill: "url(#paint22_linear_2577_2660)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0255 104.083C22.0255 102.773 20.9983 101.711 19.7312 101.711C18.4641 101.711 17.4369 102.773 17.4369 104.083C17.4369 105.393 18.4641 106.455 19.7312 106.455C20.9983 106.455 22.0255 105.393 22.0255 104.083Z",
    fill: "url(#paint23_linear_2577_2660)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4624 104.083C39.4624 102.773 38.4352 101.711 37.168 101.711C35.9009 101.711 34.8737 102.773 34.8737 104.083C34.8737 105.393 35.9009 106.455 37.168 106.455C38.4352 106.455 39.4624 105.393 39.4624 104.083Z",
    fill: "url(#paint24_linear_2577_2660)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8993 104.083C56.8993 102.773 55.8721 101.711 54.6049 101.711C53.3378 101.711 52.3106 102.773 52.3106 104.083C52.3106 105.393 53.3378 106.455 54.6049 106.455C55.8721 106.455 56.8993 105.393 56.8993 104.083Z",
    fill: "url(#paint25_linear_2577_2660)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1808 104.083C48.1808 102.773 47.1536 101.711 45.8865 101.711C44.6194 101.711 43.5922 102.773 43.5922 104.083C43.5922 105.393 44.6194 106.455 45.8865 106.455C47.1536 106.455 48.1808 105.393 48.1808 104.083Z",
    fill: "url(#paint26_linear_2577_2660)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.6432 92.699C93.7253 92.699 98.6559 87.6024 98.6559 81.3153C98.6559 75.0282 93.7253 69.9315 87.6432 69.9315C81.561 69.9315 76.6304 75.0282 76.6304 81.3153C76.6304 87.6024 81.561 92.699 87.6432 92.699ZM87.6432 99.8139C97.5267 99.8139 105.539 91.5318 105.539 81.3153C105.539 71.0988 97.5267 62.8167 87.6432 62.8167C77.7596 62.8167 69.7474 71.0988 69.7474 81.3153C69.7474 91.5318 77.7596 99.8139 87.6432 99.8139Z",
    fill: "url(#paint27_linear_2577_2660)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.3362 91.6065C99.6802 90.2173 101.859 90.2173 103.203 91.6065L117.567 106.454C118.91 107.843 118.91 110.095 117.567 111.485C116.223 112.874 114.043 112.874 112.7 111.485L98.3362 96.6375C96.9923 95.2482 96.9923 92.9958 98.3362 91.6065Z",
    fill: "url(#paint28_linear_2577_2660)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2577_2660",
    x1: 25.9115,
    y1: 57.9457,
    x2: 37.8191,
    y2: 73.3304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19113E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#041D75"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2577_2660",
    x1: 22.4849,
    y1: 62.8696,
    x2: 23.9128,
    y2: 69.6549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19113E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#041D75"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2577_2660",
    x1: 25.8439,
    y1: 19.4637,
    x2: 42.2388,
    y2: 39.4497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19113E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#041D75"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2577_2660",
    x1: 25.8437,
    y1: 27.505,
    x2: 27.5483,
    y2: 35.6645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19113E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#041D75"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2577_2660",
    x1: 33.9118,
    y1: 27.9163,
    x2: 76.6379,
    y2: 85.9884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19113E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#041D75"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2577_2660",
    x1: 57.7331,
    y1: 26.2093,
    x2: 58.1344,
    y2: 30.5325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19113E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#041D75"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2577_2660",
    x1: 57.0866,
    y1: 35.2455,
    x2: 57.5158,
    y2: 39.5633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19113E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#041D75"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2577_2660",
    x1: 55.7936,
    y1: 17.1735,
    x2: 56.2919,
    y2: 21.4762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19113E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#041D75"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2577_2660",
    x1: 54.5609,
    y1: 64.651,
    x2: 55.1679,
    y2: 68.9252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19113E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#041D75"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2577_2660",
    x1: 54.018,
    y1: 73.6627,
    x2: 54.6789,
    y2: 77.9206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19113E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#041D75"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2577_2660",
    x1: 55.7936,
    y1: 55.5777,
    x2: 56.2919,
    y2: 59.8805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19113E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#041D75"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2577_2660",
    x1: 1.35748,
    y1: 94.0585,
    x2: 3.37091,
    y2: 97.075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19113E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#041D75"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2577_2660",
    x1: 1.35748,
    y1: 103.071,
    x2: 3.37091,
    y2: 106.088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19113E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#041D75"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2577_2660",
    x1: 1.35748,
    y1: 75.8988,
    x2: 3.0898,
    y2: 78.7826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19113E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#041D75"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2577_2660",
    x1: 1.35748,
    y1: 85.0465,
    x2: 3.37091,
    y2: 88.0631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19113E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#041D75"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2577_2660",
    x1: 1.35748,
    y1: 57.8749,
    x2: 3.0898,
    y2: 60.7586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19113E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#041D75"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2577_2660",
    x1: 1.35748,
    y1: 66.8868,
    x2: 3.0898,
    y2: 69.7706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19113E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#041D75"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2577_2660",
    x1: 1.35748,
    y1: 39.8497,
    x2: 3.0898,
    y2: 42.7335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19113E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#041D75"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2577_2660",
    x1: 1.35748,
    y1: 30.838,
    x2: 3.0898,
    y2: 33.7218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19113E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#041D75"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2577_2660",
    x1: 1.35748,
    y1: 21.826,
    x2: 3.0898,
    y2: 24.7098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19113E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#041D75"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2577_2660",
    x1: 1.35748,
    y1: 48.8617,
    x2: 3.0898,
    y2: 51.7454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19113E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#041D75"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2577_2660",
    x1: 10.0759,
    y1: 103.071,
    x2: 12.0894,
    y2: 106.088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19113E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#041D75"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2577_2660",
    x1: 27.5128,
    y1: 103.071,
    x2: 29.5262,
    y2: 106.088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19113E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#041D75"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2577_2660",
    x1: 18.7943,
    y1: 103.071,
    x2: 20.8078,
    y2: 106.088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19113E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#041D75"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2577_2660",
    x1: 36.2312,
    y1: 103.071,
    x2: 38.2446,
    y2: 106.088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19113E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#041D75"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2577_2660",
    x1: 53.6681,
    y1: 103.071,
    x2: 55.6815,
    y2: 106.088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19113E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#041D75"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2577_2660",
    x1: 44.9496,
    y1: 103.071,
    x2: 46.9631,
    y2: 106.088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19113E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#041D75"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2577_2660",
    x1: 80.3357,
    y1: 73.4245,
    x2: 96.0405,
    y2: 96.9536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19113E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#041D75"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2577_2660",
    x1: 105.063,
    y1: 96.4141,
    x2: 101.257,
    y2: 101.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19113E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#041D75"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoFound);
export default __webpack_public_path__ + "static/media/no_found.b32ed5bcec90815c5426ea94e7e32f2e.svg";
export { ForwardRef as ReactComponent };